export default "__VITE_ASSET__6rew4R7y__"